import { render, staticRenderFns } from "./PortraitPage.vue?vue&type=template&id=82650926&scoped=true&"
import script from "./PortraitPage.vue?vue&type=script&lang=js&"
export * from "./PortraitPage.vue?vue&type=script&lang=js&"
import style0 from "./PortraitPage.vue?vue&type=style&index=0&id=82650926&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82650926",
  null
  
)

export default component.exports